<template>
  <Content class="col-span-full" :title="$route.name" :showAdd="false" :pagination="{
    count: tableData.count,
    current: +$route.query.p,
    request: 'devices/',
  }" @tableData="tableData = $event" @loading="loading = $event">
    <tableSearch @search="search = $event" :placeholder="$t('SEARCH_FOR', { type: $t('SIM_NUMBER') })" />

    <el-table :empty-text="$t('NO_DATA')" :data="
      tableData.results.filter(
        (data) => !search || data.sim_number.includes(search)
      )
    " v-loading="loading" :stripe="true" :default-sort="{ prop: 'id', order: 'descending' }" style="width: 100%">
      <el-table-column sortable type="index" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('INDEX')"
        width="60">
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sim_number" sortable :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('SIM_NUMBER')" width="160">
        <template slot-scope="scope">
          <div :data-title="$t('SIM_NUMBER')">
            {{ "0" + scope.row.sim_number }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="device_model" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('DEVICE_MODEL')"
        width="120">
        <template slot-scope="scope">
          <div :data-title="$t('DEVICE_MODEL')">
            {{ scope.row.device_model.title }} -
            {{
              $i18n.locale == "fa"
              ? scope.row.device_model.device_manufacturer_company.fa_title
              : scope.row.device_model.device_manufacturer_company.en_title
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="serial_number" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('SERIALNUMBER')"
        width="120">
        <template slot-scope="scope">
          <div :data-title="$t('SERIALNUMBER')">
            {{ scope.row.serial_number }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="imei" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('IMEI')" width="120">
        <template slot-scope="scope">
          <div :data-title="$t('IMEI')">
            {{ scope.row.imei }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="20"> </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { devicesList } from "@/api/devices";
import tableSearch from "@/components/elements/tableSearch";

export default {
  data() {
    return {
      tableData: {
        results: [],
      },
      search: "",
      loading: true,
    };
  },

  methods: {},
  mounted() {
    devicesList.api().then((res) => {
      if (res) {
        this.tableData = res;
        this.loading = false;
      }
    });
  },
  components: {
    tableSearch,
  },
};
</script>
